'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isRegExp(value) {
    return value instanceof RegExp;
}
exports.isRegExp = isRegExp;
